import { Outlet, createFileRoute } from '@tanstack/react-router';

/** Layout for `/casino/$category/*` nested routes. */
export const Route = createFileRoute('/casino/$category')({
  component: () => <Outlet />,
});
